module.exports = __webpack_public_path__ + "img/playbutton23.aa492077.png";